// Static on purpose: the failing part may be a lazy chunk or the translation files themselves.
const TEXTS = {
    de: { message: "Die Seite konnte nicht geladen werden, vermutlich wurde kisscal gerade aktualisiert.", reload: "Neu laden" },
    en: { message: "The page could not be loaded, kisscal has probably just been updated.", reload: "Reload" },
    es: { message: "No se pudo cargar la página; probablemente kisscal se acaba de actualizar.", reload: "Recargar" },
    fr: { message: "La page n'a pas pu être chargée, kisscal vient probablement d'être mis à jour.", reload: "Recharger" },
    it: { message: "Impossibile caricare la pagina, probabilmente kisscal è appena stato aggiornato.", reload: "Ricarica" },
    pl: { message: "Nie udało się załadować strony, prawdopodobnie kisscal został właśnie zaktualizowany.", reload: "Odśwież" },
};

export const getErrorBoundaryTexts = (language) => TEXTS[(language || "").slice(0, 2).toLowerCase()] || TEXTS.en;
